import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../services/AxiosInstance';
import { handleErrors } from '../CitoPlus/components/ErrorHandlingComponent';


const CardsAdministradores = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [totalParking, setTotalParking] = useState(0);

  const fetchDataParkingTotales = async () => {
    try {
      const response = await axiosInstance.get('/api/v3/parking/recaudo/totales/');
      setTotalParking(response.data);
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get('/rest-auth/user/');
      setData(response.data);
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataParkingTotales();
    fetchData();
  }, []);

  return (
    <>
      <div className="container mt-5">
        <div className="row text-center">
          <div className="col-md-3">
            <div className="card overflow-hidden">
              <div className="social-graph-wrapper widget-facebook">
                <span className="s-icon">
                  Fecha Vencimiento
                </span>
              </div>
              <div className="row">
                <div className="pt-3 pb-3 ps-0 pe-0 text-center">
                  <h4 className="m-1">
                    <span className="counter">{data.perfil_extra?.fecha_vencimiento}</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card overflow-hidden">
              <div className="social-graph-wrapper widget-facebook">
                <span className="s-icon">
                  Inmuebles Creados
                </span>
              </div>
              <div className="row">
                <div className="pt-3 pb-3 ps-0 pe-0 text-center">
                  <h4 className="m-1">
                    <span className="counter">{data.perfil_extra?.total_inmubles} de {data.perfil_extra?.cant_citofonos}</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card overflow-hidden">
              <div className="social-graph-wrapper widget-facebook">
                <span className="s-icon">
                  SMS
                </span>
              </div>
              <div className="row">
                <div className="pt-3 pb-3 ps-0 pe-0 text-center">
                  <h4 className="m-1">
                    <span className="counter">Saldo: {data.perfil_extra?.saldo}</span>
                  </h4>
                  <h4>
                    <span className="counter">
                      Cantidad de sms: {data.perfil_extra?.saldo && data.perfil_extra?.costo_sms ?
                        Math.floor(data.perfil_extra.saldo / data.perfil_extra.costo_sms) : 0}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card overflow-hidden">
              <div className="social-graph-wrapper widget-facebook">
                <span className="s-icon">
                  Recaudo Vehicular
                </span>
              </div>
              <div className="row">
                <div className="pt-3 pb-3 ps-0 pe-0 text-center">
                  <h4>
                    <span className="counter">
                      Total Mensual: $ {totalParking.total}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card overflow-hidden">
              <div className="social-graph-wrapper widget-facebook">
                <span className="s-icon">
                  CORREOS
                </span>
              </div>
              <div className="row">
                <div className="pt-3 pb-3 ps-0 pe-0 text-center">
                  <h4 className="m-1">
                    <span className="counter">Activos: {data.perfil_extra?.emails_enviados} | Errados: {data.perfil_extra?.email_malos}</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default CardsAdministradores;
